import cn from './reports.module.css';

const ReportHeader = () => (
  <div className={cn.reportHeader}>
    <div className={`${cn.reportHeaderValue} ${cn.reportHeaderName}`}>
      <span>Description</span>
    </div>
    <div className={cn.reportHeaderValue}>
      <span>Acc. type</span>
    </div>
    <div className={cn.reportHeaderValue}>
      <span>Debit IN</span>
    </div>
    <div className={cn.reportHeaderValue}>
      <span>Credit IN</span>
    </div>
    <div className={cn.reportHeaderValue}>
      <span>Debit TO</span>
    </div>
    <div className={cn.reportHeaderValue}>
      <span>Credit TO</span>
    </div>
    <div className={cn.reportHeaderValue}>
      <span>Debit OUT</span>
    </div>
    <div className={cn.reportHeaderValue}>
      <span>Credit OUT</span>
    </div>
  </div>
);

export default ReportHeader;
